import { useState } from "react"
import { ref, uploadBytes } from "firebase/storage"
import { storage } from "../core"

export const UploadToFireStorageInput = (p: {
  label: string
  uploadPath: string,
  onChange: (successfullyUploaded: boolean) => void,
  disabled: boolean
}) => {
  const [hasFile, setHasFile] = useState(false)
  const onSelectFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.item(0)
    if (file === undefined || file === null) {
      setHasFile(false)
      p.onChange(false)
      return
    }
    const reader = new FileReader()
    reader.addEventListener(
      "load",
      async () => {
        if (reader.result === null) {
          alert("file reading failed!")
          setHasFile(false)
          p.onChange(false)
          return
        }
        await uploadBytes(ref(storage, p.uploadPath), reader.result as ArrayBuffer, { contentType: file.type }).then(() => {
          setHasFile(true)
          p.onChange(true)
        }).catch((e) => {
          alert("file too large or incompatible type!")
          setHasFile(false)
          p.onChange(false)
          console.error(e)
        })
      },
      false,
    )
    reader.readAsArrayBuffer(file)
  }

  return <div>
    <div className="form-floating">
      <input type="file" className="form-control" disabled={p.disabled} onChange={(e) => onSelectFile(e)} />
      <label>{p.label}</label>
    </div>
    {hasFile && <p className="badge bg-secondary">アップロード済み</p>}
  </div>
}

